/**
 * Turn a slug-style segment into a display label:
 *   "turtle-neck"   -> "Turtle Neck"
 *   "soft_knits"    -> "Soft Knits"
 *   "summerSale"    -> "Summer Sale"
 */
export function humanizeString(str: string) {
  if (typeof str !== "string") return "";
  const normalized = str
    .replace(/[-_]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2");
  return normalized.replace(/\b\w/g, (c) => c.toUpperCase()).trim();
}
